import PropTypes from 'prop-types';
import { renderReceiptPreview } from '../utils/receiptPreview';

/**
 * A receipt shrunk to a thumbnail.
 *
 * It is the real preview text at the real character width, only small — so a
 * 58mm design visibly reads narrower than an 80mm one, and a design that prints
 * no address is visibly shorter.
 *
 * It is a shape, not something to read: at this size the words are not legible,
 * and a screen that needs them legible should open the full preview instead of
 * enlarging this. Cards that use it are clickable for exactly that reason.
 */
export const ReceiptThumb = ({ org, settings, height = 104, scale = 4 }) => (
  <div className="relative bg-slate-50 overflow-hidden" style={{ height }}>
    <pre
      className="font-mono text-slate-500 whitespace-pre p-1.5"
      style={{ fontSize: `${scale}px`, lineHeight: '1.45' }}
    >
{renderReceiptPreview(org, settings)}
    </pre>
    {/* Fades the clipped bottom edge, so a cut-off line reads as "there is more"
        rather than as a rendering fault. */}
    <div className="absolute inset-x-0 bottom-0 h-6 bg-gradient-to-t from-slate-50 to-transparent" />
  </div>
);

ReceiptThumb.propTypes = {
  org: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  height: PropTypes.number,
  scale: PropTypes.number,
};
